import Swal from 'sweetalert2';

const useAlert = (icon, message) => {
  const swal = Swal.fire({
    toast: true,
    icon: icon,
    html: `<span style="color: white;">${message}<span>`,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
      popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })

  return swal
}

export default useAlert